import { render } from "./TodaysPicks.vue?vue&type=template&id=15c68ecd&scoped=true"
import script from "./TodaysPicks.vue?vue&type=script&lang=js"
export * from "./TodaysPicks.vue?vue&type=script&lang=js"

import "./TodaysPicks.vue?vue&type=style&index=0&id=15c68ecd&scoped=true&lang=css"
import "./TodaysPicks.vue?vue&type=style&index=1&id=15c68ecd&scoped=true&lang=css"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c68ecd"]])

export default __exports__